export class Car {
  constructor() {
    this.id = '';
    this.name = '';
    this.msrp = {
      value: null,
      currency: 'USD'
    };
    this.listPrice = {
      value: null,
      currency: 'USD'
    };
    this.invoicePrice = {
      value: null,
      currency: 'USD'
    };
    this.make = '';
    this.year = '';
    this.trim = '';
    this.model = '';
    this.modelDescription = '';

    this.inventoryDetail = {
      vin: '',
      stockNumber: '',
      type: '',
      inventoryDate: ''
    };

    this.powertrain = {
      engine: '',
      transmission: '',
      drivetrain: '',
      fuelType: ''
    };

    this.image = '../img/NoCarImageSmall.jpg';
  }
}

export class CarMap {
  map = vehicles => {
    const data = [];
    for (const v of vehicles) {
      try {
        // Build UI Dto
        const car = new Car();
        car.id = v.id;
        car.name = `${v.vehicle.year} ${v.vehicle.make} ${v.vehicle.model.marketingName} ${v.vehicle.trim.marketingName}`;
        car.modelDescription = `${v.vehicle.model.marketingName}`;
        car.model = `${v.vehicle.model.marketingName}`;
        car.trim = `${v.vehicle.trim.marketingName}`;

        if (v && v.prices !== undefined) {
          if (v.prices.msrp) {
            car.msrp.value = v.prices.msrp.value;
            car.msrp.currency = v.prices.msrp.currency;
          }

          if (v.prices.invoicePrice) {
            car.invoicePrice.value = v.prices.invoicePrice.value;
            car.invoicePrice.currency = v.prices.invoicePrice.currency;
          }

          if (v.prices.listPrice) {
            car.listPrice.value = v.prices.listPrice.value;
            car.listPrice.currency = v.prices.listPrice.currency;
          }
        }

        car.make = v.vehicle.make;
        car.year = v.vehicle.year;

        // Inventory detail
        const inventoryDate = new Date(v.inventoryDetail.statusChangedDate).toLocaleString('en-US').split(', ');

        car.inventoryDetail.vin = v.inventoryDetail.vin;
        car.inventoryDetail.stockNumber = v.inventoryDetail.stockNumber;
        car.inventoryDetail.type = v.inventoryDetail.type;
        car.inventoryDetail.inventoryDate = inventoryDate;

        // Powertrain
        if (v && v.vehicle.powertrain && v.vehicle.powertrain.engine) {
          car.powertrain.engine = `${v.vehicle.powertrain.engine.primaryDescription}`;
          car.powertrain.transmission = `${v.vehicle.powertrain.transmission.primaryDescription}`;
        }

        data.push(car);
      } catch (e) {
        const car = new Car();
        car.id = v.id;
        car.name = `Vehicle with the id of ${v.id}, has missing data points required to load a car.`;

        data.push(car);
        continue;
      }
    }

    return data;
  };
}



// WEBPACK FOOTER //
// ./src/components/vehicles/car.model.js